<ion-content scrollY="false">
  <ion-list lines="full">

    @if (permissionService.isPermitted('pos-organisations-shipping-addresses-edit-shipping-address')) {
      <ion-item button="true" (click)="edit()">
        <ion-label><fa-icon [icon]="['fal', 'pencil']" size="lg" [fixedWidth]="true"></fa-icon>Edit</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-organisations-shipping-addresses-delete-shipping-address')) {
      <ion-item button="true" (click)="presentDeleteAlert()">
        <ion-label><fa-icon [icon]="['fal', 'trash-alt']" size="lg" [fixedWidth]="true"></fa-icon>Delete</ion-label>
      </ion-item>
    }

  </ion-list>
</ion-content>
